<template>
    <div class="toggleSwitch" :class="{ disabled }">
        <table>
            <tr>
                <td>
                    <label :class="{ toggle: true, offAsOn }" :style="{ width: width + 'px' }">
                        <input type="checkbox" v-model="innerModel" :disabled="disabled" />
                        <span :data-checked="onText" :data-unchecked="offText"></span>
                    </label>
                </td>

                <td v-if="$slots.default" class="labelText" @click="switchValue">
                    <slot></slot>
                </td>
            </tr>
        </table>
    </div>
</template>

<script>
/* eslint-disable vue/require-prop-types */

export default {
    name: 'ToggleSwitch',

    model: {
        prop: 'outerModel'
    },

    props: {
        onText: {
            type: String,
            default: 'ON'
        },
        offText: {
            type: String,
            default: 'OFF'
        },
        onValue: {
            default: true
        },
        offValue: {
            default: false
        },
        offAsOn: {
            type: Boolean,
            default: false
        },
        width: {
            type: [Number, String],
            default: 80
        },
        disabled: {
            type: Boolean,
            default: false
        },
        outerModel: {
            required: true
        }
    },

    computed: {
        innerModel: {
            get() {
                return this.outerModel === this.onValue;
            },
            set(value) {
                const mappedValue = value ? this.onValue : this.offValue;
                this.$emit('input', mappedValue);
                this.$emit('change', mappedValue);
            }
        }
    },

    methods: {
        switchValue() {
            if (!this.disabled) {
                this.innerModel = !this.innerModel;
            }
        }
    }
};
</script>

<style lang="scss">
@import '../assets/styles/settings';

.toggleSwitch {
    $toggle-height: 23px;

    .toggle {
        overflow: hidden;
        display: inline-block;
        height: $toggle-height;
        border: 1px solid $color_gray_very_light;
        border-radius: 4px;
        font-size: 13px;
        cursor: pointer;

        input {
            position: absolute;
            visibility: hidden;
        }

        span {
            position: relative;
            left: 50%;
            display: block;
            text-align: center;
            line-height: $toggle-height - 2px;
            transition: left 100ms ease-out;

            &:before {
                content: attr(data-unchecked);
                background: $color_gray_whisper;
                color: $color_gray_nero;
                display: block;
                width: 50%;
                height: $toggle-height;
            }
        }

        :checked + span {
            left: 0%;

            &:before {
                content: attr(data-checked);
            }
        }

        &.offAsOn span,
        :checked + span {
            &:before {
                background: $color_ci_blue_shade1;
                color: $color_white;
            }
        }
    }

    .labelText {
        font-weight: bold;
        padding-left: 15px;
        cursor: pointer;
    }

    &.disabled {
        .toggle {
            cursor: not-allowed;
        }

        &.offAsOn span,
        .toggle span {
            &:before {
                background: $color_gray_nobel;
                color: $color_white;
            }
        }

        .labelText {
            cursor: default;
            color: $color_gray_nobel;
        }
    }
}
</style>
